import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEOProps } from '../../utils/seo';

interface SEOComponentProps extends SEOProps {
  pathname: string;
}

const SEO: React.FC<SEOComponentProps> = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  author,
  noindex = false,
  structuredData,
  pathname,
}) => {
  const fullTitle = title;
  const fullDescription = description;
  const fullKeywords = keywords;
  const imageUrl = image?.startsWith('http') ? image : `${url}${image}`;
  const canonicalUrl = `${url}${pathname}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={fullDescription} />
      {fullKeywords && <meta name="keywords" content={fullKeywords} />}
      {author && <meta name="author" content={author} />}
      
      {/* Robots Meta Tags */}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <meta name="googlebot" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      <meta property="og:site_name" content="The United Travel" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      
      {/* Additional Meta Tags */}
      <meta name="geo.region" content="US" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;

